import { writable, get } from "svelte/store";
import { LayerManager } from "./LayerManager";
import { WritableSet } from "../../shared/WritableSet";
export class LayersManager {
    constructor(parent, visibleVehicles) {
        this.layers = writable([]);
        this.visibleLayers = new WritableSet();
        this.parent = parent;
        this.visibleVehicles = visibleVehicles;
    }
    async initialize(layers) {
        this.layers.set(layers.map(x => new LayerManager(this, x)));
        get(this.layers).forEach((lm, i) => {
            lm.getVisibleStore().subscribe(v => {
                if (v) {
                    this.visibleLayers.add(lm.getId());
                }
                else {
                    this.visibleLayers.delete(lm.getId());
                }
            });
        });
    }
    getDestinationTrafficStore() {
        return this.parent.getDestinationTrafficStore();
    }
    getThroughTrafficStore() {
        return this.parent.getThroughTrafficStore();
    }
    getLayerManagersStore() {
        return this.layers;
    }
    getVisibleLayersStore() {
        return this.visibleLayers;
    }
    getVisibleVehiclesStore() {
        return this.visibleVehicles;
    }
}
